/**
 * Dependencies.
 */
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

import { ServicePointOrderModel } from './order.model';

/**
 * Service.
 */
class ServicePointOrderService extends BaseService<ServicePointOrderModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      ServicePointOrderModel,
      ServicePointOrderModel.name,
      applicationConstant.apiServicePointPrivateUrl
    );
  }

  /**
   * Get by key.
   */
  getByKey(key: string): Promise<ServicePointOrderModel> {
    return this.GET(`${this.getModelEndpoint}/${key}`);
  }

  /**
   * Get by pin.
   */
  getByPin(pin: string): Promise<ServicePointOrderModel> {
    return this.GET(`${this.getModelEndpoint}/pin/${pin}`);
  }

  /**
   * Mark has collected.
   */
  markHasCollected({ trackingNumber }: { trackingNumber: string }) {
    return this.POST(
      `${this.getModelEndpoint}/${trackingNumber}/receiveToCollect`,
      {}
    );
  }

  /**
   * Deliver without pin.
   */
  deliverWithOutPin({ data, deliverType }) {
    return this.POST(
      `${this.getModelEndpoint}/deliver?deliverType=${deliverType}`,
      data
    );
  }
}

/**
 * Export `servicePointOrderService`.
 */
export const servicePointOrderService = new ServicePointOrderService();
